import { ReactNode } from "react";
import { useAuth } from "src/hooks/useAuth";

export enum ClaimType {    
    GlobalUpdates = 1,
    Customers = 2,
    Sprints = 4,
    Leads = 6,
    Organisations = 7,
    Playbooks = 8,
    Roles = 10,
    Outcomes = 11,
    LeadImport = 12,
    Accounts = 13,
    Users = 14,
    Dashboard = 15,
    UserProfile = 16,
    ChatBot = 17,
    None = 1000
}

export enum ClaimValue {
    Admin = 0,
    Run = 1,
    All = 2,
    Unassigned = 3,
    UnassignedSprints = 4,
    Reset = 5,
    AddPlaybookCadence = 6,
    AddPlaybookCadenceStep = 7,
    AddPlaybookMessaging = 8,
    AddPlaybookTemplate = 9,
    AddTemplateAttachments = 10,
    AddTemplateVariantAttachments = 11,
    AddTemplateVariantFilters = 12,
    AddTemplateVariants = 13,
    AssignLeads = 14,
    Delete = 15,
    DeletePlaybookCadence = 16,
    DeletePlaybookCadenceStep = 17,
    DeletePlaybookMessaging = 18,
    DeletePlaybookTemplate = 19,
    DeleteTemplateVariantFilters = 20,
    Edit = 21,
    EditPlaybookCadence = 22,
    EditPlaybookCadenceSteps = 23,
    EditPlaybookMessaging = 24,
    EditPlaybookTemplate = 25,
    EditTemplateVariantFilters = 26,
    EditTemplateVariants = 27,
    UploadAccountLogo = 28,
    ViewPlaybookCadenceSteps = 29,
    ViewPlaybookMessaging = 30,
    ViewPlaybookTemplate = 31,
    ViewTemplateVariantFilters = 32,
    ViewTemplateVariants = 33,
    Add = 34,
    ExecuteActivities = 35,
    OverrideWorkflow = 36,
    ChangeActivity = 37,
    ChangeCadence = 38,
    ChangeSprint = 39,
    ChangeOwner = 40,
    ChangeActivityDate = 41,
    ViewNotes = 42,
    ViewTasks = 43,
    TemplateManager = 44,
    AssignUsersToRoles = 45,
    ActivateUser = 46,
    DeactivateUser = 47,
    ChangePassword = 48,
    Workqueue = 49,
    PerformanceKPIs = 50,
    ActicityComparison = 51,
    ActivitySnapshot = 52,
    AccountPenetration = 53,
    PerformanceComparison = 54,
    SetUserProfileKPIs = 55,
    AddUserProfileCustomer = 56,
    EditUserProfileCustomer = 57,
    DeleteUserProfileCustomer = 58,
    AddUserProfilePhoneNumber = 59,
    EditUserProfilePhoneNumber = 60,
    DeleteUserProfilePhoneNumber = 61,
    AddNotes = 62,
    AddTasks = 63,
    ViewCadence = 64,
    AddToCadence = 65,
    AddToSprint = 66,
    ViewSprint = 67,
    ViewActivityHistory = 68,
    SendActivationEmail = 69,
    ImportExcel = 70,
    ManualImport = 71,
    ChatBotAdmin = 72
}

type Props = {
    claimType: ClaimType,
    claimValue: ClaimValue,
    children: ReactNode | ReactNode[],
}

const RenderIf = ({ children, claimType, claimValue }: Props) => {
    const { user } = useAuth()
    
    if (!user) return null;

    if (!user.claims.some(roleClaim => roleClaim.value === claimValue && roleClaim.claim === claimType) && !user.isAdmin) return null;

    return <>
        {children}
    </>
}

export { RenderIf }
export default RenderIf;